import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { Button } from "../components/Bits";
import { getPost } from "../lib/api";

function fmt(d) {
  return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
}

export default function NewsPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getPost(slug).then(setPost).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound)
    return (
      <div className="pt-40 pb-32 text-center">
        <p className="text-nead-navy/60 text-lg">Story not found.</p>
        <div className="mt-6 flex justify-center"><Button to="/news" testId="notfound-back">Back to news</Button></div>
      </div>
    );
  if (!post) return <div className="pt-40 pb-32 text-center text-nead-navy/50">Loading…</div>;

  return (
    <article className="pt-[74px]">
      <div className="container-x max-w-3xl pt-16">
        <Link to="/news" className="inline-flex items-center gap-2 text-sm font-semibold text-nead-navy/50 hover:text-nead-pink transition-colors" data-testid="post-back">
          <ArrowLeft className="h-4 w-4" /> All news
        </Link>
        <Reveal>
          <div className="mt-8 flex items-center gap-3 text-xs font-semibold uppercase tracking-wider text-nead-cyan">
            <span>{post.category}</span><span>·</span><span>{fmt(post.date)}</span><span>·</span><span>{post.read}</span>
          </div>
          <h1 className="mt-5 font-display font-bold text-4xl sm:text-5xl leading-[1.06] tracking-tight text-nead-navy">{post.title}</h1>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="container-x mt-12">
          <div className="overflow-hidden rounded-[1.75rem] aspect-[16/9]">
            <img src={post.image} alt={post.title} className="h-full w-full object-cover" />
          </div>
        </div>
      </Reveal>

      <div className="container-x max-w-3xl py-16">
        {post.body.split("\n\n").map((para, i) => (
          <Reveal key={i} delay={0.02 * i}>
            <p className="mb-6 text-lg leading-[1.8] text-nead-navy/75">{para}</p>
          </Reveal>
        ))}
        <div className="mt-12 rounded-[1.5rem] bg-nead-mist p-8">
          <p className="font-display font-bold text-2xl text-nead-navy">Want to be part of it?</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Button to="/get-involved" variant="pink" testId="post-volunteer">Get involved</Button>
            <Button to="/donate" variant="outline" testId="post-donate">Donate</Button>
          </div>
        </div>
      </div>
    </article>
  );
}
